module.exports = "/_next/static/resources/photo-4-ef73619d4bde2fd0885489f86e92a00f.jpg";